export const UserData = [
    {
        username: 'Name of User',
        username: 'username',
        useraddress: 'Akurdi, Pune',
        usermedicalhistory: [
            {
                date: '22/03/2023',
                condition: 'High Blood Pressure',
                treatment: '2 Month Check Up',
            },
            {
                date: '28/07/2023',
                condition: 'Diabetes',
                treatment: 'Daily Injections',
            },
            {
                date: '22/03/2023',
                condition: 'High Blood Pressure',
                treatment: '2 Month Check Up',
            },
            {
                date: '28/07/2023',
                condition: 'Diabetes',
                treatment: 'Daily Injections',
            },
        ]
    },
];

export default UserData;